module.exports = __webpack_public_path__ + "static/media/galerija_2014 (33).615e6821.jpg";